import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

import { NumberTextField as DsNumberTextField } from '@montugroup/design-system';

import type { InputElementProps } from '@/pages/components/form-fields/input/types';

const NumberTextField = ({
  type: _type,
  onChange,
  name,
  value,
  inputProps,
  defaultValue: _defaultValue,
  ...restInputProps
}: InputElementProps) => {
  const { trigger, setError } = useFormContext();

  const onValueChange = useCallback(
    ({ value: rawValue }: { value: string }) => {
      if (inputProps?.format) {
        onChange(rawValue);
      } else {
        onChange(parseInt(rawValue, 10));
      }
      trigger(name);
    },
    [inputProps?.format, name, onChange, trigger],
  );

  const onBlur = useCallback(() => {
    if (inputProps?.format && inputProps?.format.replace(/\s/g, '').length > value.toString().trim().length) {
      setError(name, { type: 'custom', message: 'invalid format' });
    } else if (Number(value) < 0) {
      setError(name, { type: 'custom', message: 'invalid value' });
    }
  }, [inputProps?.format, name, setError, value]);

  if (inputProps?.format) {
    return (
      <DsNumberTextField
        format={inputProps.format}
        onValueChange={onValueChange}
        onBlur={onBlur}
        value={value as string}
        slotProps={{ htmlInput: inputProps }}
        {...restInputProps}
      />
    );
  }

  return (
    <DsNumberTextField
      onValueChange={onValueChange}
      onBlur={onBlur}
      value={value as string}
      allowNegative={false}
      inputProps={{ min: 0, ...inputProps }}
      slotProps={{ htmlInput: inputProps }}
      {...restInputProps}
    />
  );
};
export default NumberTextField;
